export var FAIRE_EMPLOYEE_GROUPS = function(strictLocalize) {
    return [
        {
            title: strictLocalize({
                id: "JOF/H4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Black Faire Folk"
                    }
                ]
            }),
            description: strictLocalize({
                id: "x7YlAG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Fostering and promoting an inclusive space to celebrate the diversity of black employees at Faire."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "MY5G7A",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire Femmes"
                    }
                ]
            }),
            description: strictLocalize({
                id: "Tuh8M1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "A community for women, dedicated to empowering those at Faire who identify as women to succeed."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "Hr8ACg",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire Femmes in Tech"
                    }
                ]
            }),
            description: strictLocalize({
                id: "f2xsRQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nurturing a sense of belonging among women engineers at Faire, by supporting career growth and development, facilitating professional connections, and mentorship."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "v+Ks6z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faire Fusion"
                    }
                ]
            }),
            description: strictLocalize({
                id: "MMtAM4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "A tight-knit community that provides support and mentorship, while celebrating the diverse spectrum of cultures represented in the AAPI community at Faire."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "7TkLB+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Fairents"
                    }
                ]
            }),
            description: strictLocalize({
                id: "2/d0eC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "A community of parents supporting one another in their professional ambitions and journeys as parents."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "Pw3dvV",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Flaire"
                    }
                ]
            }),
            description: strictLocalize({
                id: "Fv2j1S",
                defaultMessage: [
                    {
                        type: 0,
                        value: "An inclusive LGBTQ+ community empowering everyone to express their whole selves at work."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "R0Hq07",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Hue"
                    }
                ]
            }),
            description: strictLocalize({
                id: "kSr7Ku",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Providing an inclusive space where people of color and their allies can feel comfortable being themselves and talk to others who get it."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "RTIKPb",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Somos"
                    }
                ]
            }),
            description: strictLocalize({
                id: "BnZhmf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Empowering and uplifting Latinx/Hispanic Faire Folk by strengthening members' connection to each other, other Faire Folk, and the broader Faire community."
                    }
                ]
            })
        },
        {
            title: strictLocalize({
                id: "SznAkQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "South Asian Faire Folk"
                    }
                ]
            }),
            description: strictLocalize({
                id: "4+twPn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "A space for all South Asians or those who have a connection to South Asian culture to connect over shared experiences."
                    }
                ]
            })
        }
    ];
};
